import { Subject } from 'rxjs';
import { Gizmo } from '../../gizmos';
import { IGizmoData } from '../../types';
import CommonBinder from '../common-binder';

class FolioBinder extends CommonBinder {
  public value: Subject<string>;

  constructor(gizmo: Gizmo) {
    super(gizmo);

    this.value = new Subject<string>();
  }

  public init = (): Promise<void> => {
    return new Promise<void>(async resolve => {
      resolve();
    });
  };

  /**
   * Get the folio from the gizmos data
   * @returns {string} folio value
   */
  public getValue = (): string | undefined => {
    const data = this._gizmo.getData() as IGizmoData;

    if (data?.v && typeof data.v === 'string') {
      return data.v;
    }

    return 'El folio se definirá cuando se suba la información.';
  };
}

export default FolioBinder;
